import {MessageCircle,Sparkles} from 'lucide-react';
import type {ThreadRecord} from '@reados/contracts';

/** Exact octicons.git-branch-24 geometry from the transcript's “从对话中派生” notice. */
export function ForkConversationIcon({size=18}:{size?:number}){
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-conversation-icon="fork">
    <path d="M15 4.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM2.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0-14.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM5.75 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 6.5Zm0 14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 5.75 21Zm12.5-14.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 18.25 6.5Z"/>
    <path d="M5.75 16.75A.75.75 0 0 1 5 16V8a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75Z"/>
    <path d="M17.5 8.75v-1H19v1a3.75 3.75 0 0 1-3.75 3.75h-7a1.75 1.75 0 0 0-1.75 1.75H5A3.25 3.25 0 0 1 8.25 11h7a2.25 2.25 0 0 0 2.25-2.25Z"/>
  </svg>;
}

export function conversationKindLabel(thread:ThreadRecord){return thread.quickChat?'快捷问答':thread.forkKind==='fork'?'分叉':thread.forkKind==='side-chat'?'侧聊':thread.forkedFromThreadId?'对话':'主对话';}

/** Keep the side-chat glyph identical to lucide's MessageSquareText without
 * adding a new dependency module to the published bundle graph. */
function SideChatIcon(){
  return <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-conversation-icon="side-chat">
    <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/>
    <path d="M7 11h10"/><path d="M7 15h6"/><path d="M7 7h8"/>
  </svg>;
}

export function ConversationKindIcon({thread}:{thread:ThreadRecord}){
  return thread.quickChat?<Sparkles size={18} strokeWidth={1.6} aria-hidden="true" data-conversation-icon="quick"/>:thread.forkKind==='fork'?<ForkConversationIcon/>:thread.forkKind==='side-chat'?<SideChatIcon/>:<MessageCircle size={18} strokeWidth={1.6} aria-hidden="true" data-conversation-icon="chat"/>;
}
